@if (loading) {
  <div class="d-flex align-items-center justify-content-center" style="height: 50vh;">
    <app-loading-spinner></app-loading-spinner>
  </div>
}

@if (!loading && !access) {
  <div class="d-flex align-items-center justify-content-center" style="height: 50vh;">
    @if (!no_plan) {
      <div class="text-center">
        <h1 class="text-warning">You do not have permission!</h1>
        <p class="text-muted">please contact revealense administration for getting access to our API.</p>
      </div>
    }
    @if (no_plan) {
      <div class="text-center">
        <h1 class="text-warning">No Subscription Found!</h1>
        <p class="text-muted">You must have an active subscription to see this page.</p>
      </div>
    }
  </div>
}

<div class="api-docs-wrapper">
  <div class="row g-0">

    <div class="col-xl-2 col-lg-3 d-none d-lg-block">
      <nav class="docs-sidebar">
        <div class="logo">
          <h2>⬡ Revealense</h2>
          <p>API Documentation · V1</p>
        </div>
        <ul>
          <li><span class="nav-section">Getting Started</span></li>
          <li><a href="#overview" [class.active]="activeSection === 'overview'" (click)="scrollToSection('overview', $event)">Overview</a></li>
          <li><a href="#auth" [class.active]="activeSection === 'auth'" (click)="scrollToSection('auth', $event)">Authentication</a></li>
          <li><a href="#workflow" [class.active]="activeSection === 'workflow'" (click)="scrollToSection('workflow', $event)">Workflow</a></li>

          <li><span class="nav-section">Conversations</span></li>
          <li><a href="#create" [class.active]="activeSection === 'create'" (click)="scrollToSection('create', $event)">Create Conversation</a></li>
          <li><a href="#analyze" [class.active]="activeSection === 'analyze'" (click)="scrollToSection('analyze', $event)">Start Analysis</a></li>
          <li><a href="#checkStatus" [class.active]="activeSection === 'status'" (click)="scrollToSection('checkStatus', $event)">Check Status</a></li>
          <li><a href="#details" [class.active]="activeSection === 'details'" (click)="scrollToSection('details', $event)">Get Details</a></li>
          <li><a href="#list" [class.active]="activeSection === 'list'" (click)="scrollToSection('list', $event)">List Conversations</a></li>
          <li><a href="#update" [class.active]="activeSection === 'update'" (click)="scrollToSection('update', $event)">Update Conversation</a></li>
          <li><a href="#delete" [class.active]="activeSection === 'delete'" (click)="scrollToSection('delete', $event)">Delete Conversation</a></li>
          <li><a href="#delete-video" [class.active]="activeSection === 'delete-video'" (click)="scrollToSection('delete-video', $event)">Delete Video File</a></li>

          <li><span class="nav-section">Q&amp;A</span></li>
          <li><a href="#all-answers" [class.active]="activeSection === 'all-answers'" (click)="scrollToSection('all-answers', $event)">All Q&amp;A</a></li>
          <li><a href="#single-answer" [class.active]="activeSection === 'single-answer'" (click)="scrollToSection('single-answer', $event)">Single Answer</a></li>

          <li><span class="nav-section">Reports</span></li>
          <li><a href="#gen-report" [class.active]="activeSection === 'gen-report'" (click)="scrollToSection('gen-report', $event)">Generate Report</a></li>
          <li><a href="#list-reports" [class.active]="activeSection === 'list-reports'" (click)="scrollToSection('list-reports', $event)">List Reports</a></li>
          <li><a href="#get-report" [class.active]="activeSection === 'get-report'" (click)="scrollToSection('get-report', $event)">Get Report Content</a></li>
          <li><a href="#translate-report" [class.active]="activeSection === 'translate-report'" (click)="scrollToSection('translate-report', $event)">Translate Report</a></li>
          <li><a href="#delete-report" [class.active]="activeSection === 'delete-report'" (click)="scrollToSection('delete-report', $event)">Delete Report</a></li>

          <li><span class="nav-section">Client Config</span></li>
          <li><a href="#templates" [class.active]="activeSection === 'templates'" (click)="scrollToSection('templates', $event)">Report Templates</a></li>
          <li><a href="#languages" [class.active]="activeSection === 'languages'" (click)="scrollToSection('languages', $event)">Report Languages</a></li>
          <li><a href="#questions" [class.active]="activeSection === 'questions'" (click)="scrollToSection('questions', $event)">Questions List</a></li>

          <li><span class="nav-section">Reference</span></li>
          <li><a href="#full-workflow" [class.active]="activeSection === 'full-workflow'" (click)="scrollToSection('full-workflow', $event)">Full Workflow</a></li>
          <li><a href="#errors" [class.active]="activeSection === 'errors'" (click)="scrollToSection('errors', $event)">Error Codes</a></li>
        </ul>
      </nav>
    </div>

    <div class="col-xl-10 col-lg-9">
      <main class="docs-main">

        <div class="hero" id="overview">
          <div class="badge">API REFERENCE · V1</div>
          <h1>Revealense <span>API</span> Docs</h1>
          <p>Everything you need to integrate video conversation analysis, behavioral insights, and professional report generation into your application.</p>
          <div class="meta">
            <div class="meta-item">
              <div class="dot"></div>
              <span>Base URL &nbsp;</span>
              <strong>{{ baseUrl }}</strong>
            </div>
            <div class="meta-item">
              <div class="dot" style="background:#6c63ff;box-shadow:0 0 8px #6c63ff"></div>
              <span>Auth &nbsp;</span>
              <strong>API Key Header</strong>
            </div>
            <div class="meta-item">
              <div class="dot" style="background:#ffa94d;box-shadow:0 0 8px #ffa94d"></div>
              <span>Format &nbsp;</span>
              <strong>JSON</strong>
            </div>
          </div>
        </div>

        <section id="auth">
          <div class="section-header">
            <div class="section-icon purple">🔐</div>
            <div>
              <h2>Authentication</h2>
              <p>Every request must carry your API key — no exceptions</p>
            </div>
          </div>

          <div class="auth-card">
            <h3>Include this header in every request</h3>
            <div class="key-demo">
              <div class="kv"><span class="k">Header Key:</span> <span class="v">revealense_key</span></div>
              <div class="kv"><span class="k">Header Value:</span> <span class="v">API Key generated from the Revealense dashboard</span></div>
            </div>
            <div class="callout tip" style="margin-top:16px">
              <span class="icon">💡</span>
              <span>Only <strong>Account Admins</strong> can generate and manage API keys from the API Key page in the Revealense dashboard. Navigate to <strong>Settings → API Keys</strong> to create yours.</span>
            </div>
          </div>

          <div class="security-grid">
            <div class="security-item do">
              <div class="si-title">✅ Use Secret Managers</div>
              <p>Store keys in AWS Secrets Manager, GCP Secret Manager, or Azure Key Vault.</p>
            </div>
            <div class="security-item do">
              <div class="si-title">✅ Use HTTPS Only</div>
              <p>All API requests must be made over HTTPS. Plain HTTP will be rejected.</p>
            </div>
            <div class="security-item dont">
              <div class="si-title">❌ Never Hardcode Keys</div>
              <p>Do not embed API keys directly in source code or client-side scripts.</p>
            </div>
            <div class="security-item dont">
              <div class="si-title">❌ Never Commit to Git</div>
              <p>Never push API keys to GitHub or any version control system.</p>
            </div>
          </div>
        </section>

        <div class="divider"></div>

        <div class="workflow" id="workflow">
          <h3>🗺️ The Big Picture — Typical API Workflow</h3>
          <div class="flow-steps">
            <div class="flow-step"><div class="num">1</div> Create Conversation</div>
            <div class="flow-arrow">→</div>
            <div class="flow-step"><div class="num">2</div> Upload Video</div>
            <div class="flow-arrow">→</div>
            <div class="flow-step"><div class="num">3</div> Start Analysis</div>
            <div class="flow-arrow">→</div>
            <div class="flow-step"><div class="num">4</div> Poll Status</div>
            <div class="flow-arrow">→</div>
            <div class="flow-step"><div class="num">5</div> Retrieve Q&amp;A</div>
            <div class="flow-arrow">→</div>
            <div class="flow-step"><div class="num">6</div> Generate Report</div>
            <div class="flow-arrow">→</div>
            <div class="flow-step"><div class="num">7</div> Retrieve Report</div>
          </div>
        </div>

        <div class="divider"></div>

        <section>
          <div class="section-header">
            <div class="section-icon purple">💬</div>
            <div>
              <h2>Conversations</h2>
              <p>Create, manage, and analyze your video conversations</p>
            </div>
          </div>

          <div class="endpoint" id="create">
            <div class="endpoint-header">
              <span class="method POST">POST</span>
              <div class="endpoint-info">
                <h4>Create New Conversation</h4>
                <div class="url-row">
                  <div class="url-display">
                    <span class="base-url">{{ baseUrl }}</span><span class="route">/conversation/create</span>
                  </div>
                  <button class="copy-btn" (click)="copyUrl(baseUrl + '/conversation/create', $event)">📋 Copy URL</button>
                </div>
              </div>
            </div>
            <div class="endpoint-body">
              <p class="endpoint-desc">
                This is your <strong>starting point</strong>. Before you can upload a video or run any analysis, you need to register a new conversation record in the Revealense system. This call returns a unique <code class="inline">conversation_id</code> — keep it safe, you'll use it in nearly every subsequent call — and a <code class="inline">signed_url</code> which is a temporary, secure upload link directly to Client's cloud storage bucket.
              </p>
              <div class="callout warn">
                <span class="icon">⚠️</span>
                <span>The <code class="inline">signed_url</code> expires quickly. Upload your video immediately after receiving this response.</span>
              </div>
              <div class="code-block">
                <div class="code-label req-label">Request Body</div>
                <pre>&#123;
                  <span class="key">"conversation_name"</span>: <span class="str">"Interview with Candidate A"</span>,   <span class="cmt">// required</span>
                  <span class="key">"single_speaker"</span>:    <span class="str">"y"</span>,                            <span class="cmt">// optional: "y" or "n", default "y"</span>
                  <span class="key">"base_voice_start"</span>:  <span class="num">5</span>,                             <span class="cmt">// optional: seconds — start of voice baseline window</span>
                  <span class="key">"base_voice_end"</span>:    <span class="num">30</span>                            <span class="cmt">// optional: seconds — end of voice baseline window</span>
                &#125;</pre>
              </div>
              <div class="table-wrap">
                <table>
                  <thead><tr><th>Field</th><th>Type</th><th>Required</th><th>Description</th></tr></thead>
                  <tbody>
                    <tr><td><code class="inline">conversation_name</code></td><td>string</td><td><span class="req">Required</span></td><td>A human-readable label to identify this conversation.</td></tr>
                    <tr><td><code class="inline">single_speaker</code></td><td>string</td><td><span class="opt">Optional</span></td><td><code class="inline">"y"</code> for one speaker, <code class="inline">"n"</code> for multiple. Defaults to <code class="inline">"y"</code>.</td></tr>
                    <tr><td><code class="inline">base_voice_start</code></td><td>number</td><td><span class="opt">Optional</span></td><td>Start time (in seconds) of a clean voice sample for speaker profiling.</td></tr>
                    <tr><td><code class="inline">base_voice_end</code></td><td>number</td><td><span class="opt">Optional</span></td><td>End time (in seconds) of the voice sample window.</td></tr>
                  </tbody>
                </table>
              </div>
              <div class="code-block">
                <div class="code-label res-label">Response</div>
                <pre>&#123;
                  <span class="key">"conversation_id"</span>: <span class="str">"455"</span>,
                  <span class="key">"upload_url"</span>:      <span class="str">"https://BUCKET-NAME-api-storage.revealense.com/uploads/conversation-455/video.mp4?X-Amz-Algorithm=..."</span>,
                  <span class="key">"file_name"</span>:       <span class="str">"conversation-455.mp4"</span>
                &#125;</pre>
              </div>
              <div class="callout tip">
                <span class="icon">💡</span>
                <span><strong>Next step:</strong> Upload your video by sending a <code class="inline">PUT</code> request to the <code class="inline">upload_url</code> with your video as the binary body and <code class="inline">Content-Type: video/mp4</code>. Use the returned <code class="inline">file_name</code> as the file name.</span>
              </div>
            </div>
          </div>

          <div class="endpoint" id="analyze">
            <div class="endpoint-header">
              <span class="method GET">GET</span>
              <div class="endpoint-info">
                <h4>Start Analysis</h4>
                <div class="url-row">
                  <div class="url-display">
                    <span class="base-url">{{ baseUrl }}</span><span class="route">/conversation/analyze/</span><span class="param">&#123;conversation_id&#125;</span>
                  </div>
                  <button class="copy-btn" (click)="copyUrl(baseUrl + '/conversation/analyze/{conversation_id}', $event)">📋 Copy URL</button>
                </div>
              </div>
            </div>
            <div class="endpoint-body">
              <p class="endpoint-desc">
                Once your video is uploaded, call this endpoint to kick off Revealense's AI analysis engine. Replace <code class="inline">&#123;conversation_id&#125;</code> in the URL with the ID you received when creating the conversation. This is a <strong>background job</strong> — the response confirms it started, but you must poll the status endpoint to know when it's done.
              </p>
              <div class="callout tip">
                <span class="icon">💡</span>
                <span>No request body needed — just replace <code class="inline">&#123;conversation_id&#125;</code> in the URL with your actual ID (e.g., <code class="inline">.../conversation/analyze/455</code>) and send the GET request.</span>
              </div>
              <div class="code-block">
                <div class="code-label res-label">Response</div>
                <pre>&#123;
                  <span class="key">"message"</span>:         <span class="str">"Analysis started successfully"</span>
                &#125;</pre>
              </div>
            </div>
          </div>

          <div class="endpoint" id="checkStatus">
            <div class="endpoint-header">
              <span class="method GET">GET</span>
              <div class="endpoint-info">
                <h4>Get Conversation Status</h4>
                <div class="url-row">
                  <div class="url-display">
                    <span class="base-url">{{ baseUrl }}</span><span class="route">/conversation/status/</span><span class="param">&#123;conversation_id&#125;</span>
                  </div>
                  <button class="copy-btn" (click)="copyUrl(baseUrl + '/conversation/status/{conversation_id}', $event)">📋 Copy URL</button>
                </div>
              </div>
            </div>
            <div class="endpoint-body">
              <p class="endpoint-desc">
                Since analysis runs asynchronously in the background, use this endpoint to check its progress. Poll it periodically until the status returns <strong>Completed</strong> — only then can you generate reports or read answers.
              </p>
              <p style="font-size:13px;color:var(--text-muted);margin:12px 0 8px;">Possible status values:</p>
              <div class="status-grid">
                <span class="status-badge s-waiting">⏸ Waiting</span>
                <span class="status-badge s-started">▶ Started</span>
                <span class="status-badge s-analyzing">⚙ Analyzing</span>
                <span class="status-badge s-completed">✓ Completed</span>
                <span class="status-badge s-failed">✕ Failed</span>
              </div>
              <div class="code-block" style="margin-top:16px">
                <div class="code-label res-label">Response — While Analyzing</div>
                <pre>&#123;
                  <span class="key">"conversation_id"</span>: <span class="str">"455"</span>,
                  <span class="key">"status"</span>:          <span class="str">"Analyzing"</span>,
                  <span class="key">"percent"</span>:         <span class="num">47</span>
                &#125;</pre>
              </div>
              <div class="code-block">
                <div class="code-label res-label">Response — Completed</div>
                <pre>&#123;
                  <span class="key">"conversation_id"</span>: <span class="str">"455"</span>,
                  <span class="key">"status"</span>:          <span class="str">"Completed"</span>,
                  <span class="key">"percent"</span>:         <span class="num">100</span>
                &#125;</pre>
              </div>
              <div class="callout warn">
                <span class="icon">⏱️</span>
                <span><strong>Polling tip:</strong> Check every 30 seconds. Do not send requests more than once every 10 seconds.</span>
              </div>
            </div>
          </div>

          <div class="endpoint" id="details">
            <div class="endpoint-header">
              <span class="method GET">GET</span>
              <div class="endpoint-info">
                <h4>Get Conversation By ID</h4>
                <div class="url-row">
                  <div class="url-display">
                    <span class="base-url">{{ baseUrl }}</span><span class="route">/conversation/details/</span><span class="param">&#123;conversation_id&#125;</span>
                  </div>
                  <button class="copy-btn" (click)="copyUrl(baseUrl + '/conversation/details/{conversation_id}', $event)">📋 Copy URL</button>
                </div>
              </div>
            </div>
            <div class="endpoint-body">
              <p class="endpoint-desc">Retrieve full metadata and details for a specific conversation. Replace <code class="inline">&#123;conversation_id&#125;</code> in the URL with your actual ID.</p>
              <div class="code-block">
                <div class="code-label res-label">Response — Completed (with results &amp; reports)</div>
                <pre>&#123;
                  <span class="key">"conversation"</span>: &#123;
                  <span class="key">"id"</span>:             <span class="num">455</span>,
                  <span class="key">"name"</span>:           <span class="str">"Interview with Candidate A"</span>,
                  <span class="key">"file_type"</span>:      <span class="str">"UPLOAD"</span>,
                  <span class="key">"status"</span>:         <span class="str">"Completed"</span>,
                  <span class="key">"client_id"</span>:      <span class="num">8</span>,
                  <span class="key">"video_length"</span>:   <span class="num">120</span>,                        <span class="cmt">// total video duration in seconds</span>
                  <span class="key">"single_speaker"</span>: <span class="str">"y"</span>,
                  <span class="key">"baseline"</span>: &#123;
                  <span class="key">"base_voice_start"</span>: <span class="num">0</span>,
                  <span class="key">"base_voice_end"</span>:   <span class="num">10</span>,
                  <span class="key">"baseline_start"</span>:   <span class="bool">null</span>,
                  <span class="key">"baseline_end"</span>:     <span class="bool">null</span>
                  &#125;,
                  <span class="key">"createdAt"</span>: <span class="str">"2026-02-26T13:42:23.000Z"</span>,
                  <span class="key">"updatedAt"</span>: <span class="str">"2026-02-26T18:07:17.000Z"</span>,

                  <span class="cmt">// "results" is populated only when status = "Completed", otherwise null</span>
                  <span class="key">"results"</span>: &#123;
                  <span class="key">"skin_data"</span>: [
                  &#123; <span class="key">"time"</span>: <span class="num">1</span>, <span class="key">"cognitive"</span>: <span class="num">23.98</span>, <span class="key">"emotional"</span>: <span class="num">16.68</span> &#125;,
                  &#123; <span class="key">"time"</span>: <span class="num">2</span>, <span class="key">"cognitive"</span>: <span class="num">11.06</span>, <span class="key">"emotional"</span>: <span class="num">0.25</span>  &#125;,
                  <span class="cmt">// ... one entry per second of video</span>
                  ],
                  <span class="key">"engagement_data"</span>: [
                  &#123; <span class="key">"time"</span>: <span class="num">1</span>, <span class="key">"engagement"</span>: <span class="num">30.43</span> &#125;,
                  &#123; <span class="key">"time"</span>: <span class="num">2</span>, <span class="key">"engagement"</span>: <span class="num">27.96</span> &#125;,
                  <span class="cmt">// ... one entry per second of video</span>
                  ],
                  <span class="key">"skin_engagement_data"</span>: [
                  &#123; <span class="key">"time"</span>: <span class="num">1</span>, <span class="key">"cognitive"</span>: <span class="num">0</span>,   <span class="key">"emotional"</span>: <span class="num">0</span>   &#125;,
                  &#123; <span class="key">"time"</span>: <span class="num">2</span>, <span class="key">"cognitive"</span>: <span class="num">100</span>, <span class="key">"emotional"</span>: <span class="num">100</span> &#125;,
                  <span class="cmt">// ... one entry per second of video</span>
                  ],
                  <span class="key">"feelings_data"</span>: [
                  &#123; <span class="key">"time"</span>: <span class="num">1</span>, <span class="key">"emotion"</span>: <span class="str">"Threatened"</span>,  <span class="key">"confidence"</span>: <span class="num">43.92</span> &#125;,
                  &#123; <span class="key">"time"</span>: <span class="num">2</span>, <span class="key">"emotion"</span>: <span class="str">"Neutral"</span>,     <span class="key">"confidence"</span>: <span class="num">48.87</span> &#125;,
                  &#123; <span class="key">"time"</span>: <span class="num">3</span>, <span class="key">"emotion"</span>: <span class="str">"Frustration"</span>, <span class="key">"confidence"</span>: <span class="num">46.61</span> &#125;,
                  <span class="cmt">// ... one entry per second of video</span>
                  ],
                  <span class="key">"leaks_data"</span>: [
                  &#123; <span class="key">"time"</span>: <span class="num">1</span>, <span class="key">"left_brow"</span>: <span class="num">0</span>,  <span class="key">"right_brow"</span>: <span class="num">0</span>,  <span class="key">"left_eye"</span>: <span class="num">80</span>, <span class="key">"right_eye"</span>: <span class="num">80</span> &#125;,
                  &#123; <span class="key">"time"</span>: <span class="num">2</span>, <span class="key">"left_brow"</span>: <span class="num">20</span>, <span class="key">"right_brow"</span>: <span class="num">20</span>, <span class="key">"left_eye"</span>: <span class="num">0</span>,  <span class="key">"right_eye"</span>: <span class="num">0</span>  &#125;,
                  <span class="cmt">// ... one entry per second of video</span>
                  ]
                  &#125;,

                  <span class="key">"extra_content"</span>: &#123;
                  <span class="cmt">// "reports" is an empty array [] if no reports have been generated yet</span>
                  <span class="key">"reports"</span>: [
                  &#123;
                  <span class="key">"id"</span>:       <span class="str">"8927ac8c-0c58-41a9-a3e3-2cc8a6eaad6f"</span>,
                  <span class="key">"version"</span>: <span class="str">"4e34d7ea"</span>,
                  <span class="key">"template"</span>: &#123;
                  <span class="key">"name"</span>:  <span class="str">"Intelligence"</span>,
                  <span class="key">"value"</span>: <span class="str">"intellegence_template"</span>
                  &#125;,
                  <span class="key">"languages"</span>: [
                  &#123;
                  <span class="key">"code"</span>:      <span class="str">"EN"</span>,
                  <span class="key">"name"</span>:      <span class="str">"English"</span>,
                  <span class="key">"status"</span>:   <span class="str">"success"</span>,
                  <span class="key">"progress"</span>: <span class="num">100</span>,
                  <span class="key">"date"</span>:     <span class="str">"2026-02-26"</span>,
                  <span class="key">"file_path"</span>: <span class="str">"external-results/conversation-455/reports/4e34d7ea/.../intellegence_template_EN.md"</span>
                  &#125;,
                  &#123;
                  <span class="key">"code"</span>:      <span class="str">"HE"</span>,
                  <span class="key">"name"</span>:      <span class="str">"Hebrew"</span>,
                  <span class="key">"status"</span>:   <span class="str">"success"</span>,
                  <span class="key">"progress"</span>: <span class="num">100</span>,
                  <span class="key">"date"</span>:     <span class="str">"2026-02-26"</span>,
                  <span class="key">"file_path"</span>: <span class="str">"external-results/conversation-455/reports/4e34d7ea/.../intellegence_template_HE.md"</span>
                  &#125;
                  ],
                  <span class="key">"header_data"</span>: &#123;
                  <span class="key">"Subject"</span>:        <span class="str">"John Doe"</span>,
                  <span class="key">"Prepared By"</span>:    <span class="str">"Agent Sarah Miller"</span>,
                  <span class="key">"Classification"</span>: <span class="str">"Confidential"</span>,
                  <span class="key">"Source Material"</span>: <span class="str">"Zoom Recording"</span>
                  &#125;,
                  <span class="key">"video_context"</span>:   <span class="str">"Security interview regarding the warehouse incident."</span>,
                  <span class="key">"context_snippet"</span>: <span class="str">"Security interview regarding the warehouse inc..."</span>,
                  <span class="key">"created_at"</span>:     <span class="str">"2026-02-26"</span>
                  &#125;
                  ]
                  &#125;
                  &#125;
                &#125;</pre>
              </div>

              <div class="code-block">
                <div class="code-label res-label">Response — Not Completed (no results yet, no reports)</div>
                <pre>&#123;
                  <span class="key">"conversation"</span>: &#123;
                  <span class="key">"id"</span>:             <span class="num">456</span>,
                  <span class="key">"name"</span>:           <span class="str">"Interview with Candidate B"</span>,
                  <span class="key">"file_type"</span>:      <span class="str">"UPLOAD"</span>,
                  <span class="key">"status"</span>:         <span class="str">"Analyzing"</span>,
                  <span class="key">"client_id"</span>:      <span class="num">8</span>,
                  <span class="key">"video_length"</span>:   <span class="num">200</span>,
                  <span class="key">"single_speaker"</span>: <span class="str">"y"</span>,
                  <span class="key">"baseline"</span>: &#123;
                  <span class="key">"base_voice_start"</span>: <span class="num">0</span>,
                  <span class="key">"base_voice_end"</span>:   <span class="num">10</span>,
                  <span class="key">"baseline_start"</span>:   <span class="bool">null</span>,
                  <span class="key">"baseline_end"</span>:     <span class="bool">null</span>
                  &#125;,
                  <span class="key">"createdAt"</span>: <span class="str">"2026-02-27T09:00:00.000Z"</span>,
                  <span class="key">"updatedAt"</span>: <span class="str">"2026-02-27T09:05:00.000Z"</span>,
                  <span class="key">"results"</span>: <span class="bool">null</span>,           <span class="cmt">// null until analysis is Completed</span>
                  <span class="key">"extra_content"</span>: &#123;
                  <span class="key">"reports"</span>: []            <span class="cmt">// empty until a report is generated</span>
                  &#125;
                  &#125;
                &#125;</pre>
              </div>

              <div class="table-wrap" style="margin-top:16px">
                <table>
                  <thead><tr><th>Results Field</th><th>Description</th></tr></thead>
                  <tbody>
                    <tr><td><code class="inline">skin_data</code></td><td>Per-second cognitive and emotional arousal levels detected via skin analysis (0–100 scale).</td></tr>
                    <tr><td><code class="inline">engagement_data</code></td><td>Per-second engagement score (0–100 scale).</td></tr>
                    <tr><td><code class="inline">skin_engagement_data</code></td><td>Per-second binary engagement signal from skin channel — values are either <code class="inline">0</code> or <code class="inline">100</code>.</td></tr>
                    <tr><td><code class="inline">feelings_data</code></td><td>Per-second detected emotion label (e.g. <code class="inline">"Threatened"</code>, <code class="inline">"Neutral"</code>, <code class="inline">"Frustration"</code>) with a confidence score.</td></tr>
                    <tr><td><code class="inline">leaks_data</code></td><td>Per-second micro-expression leakage scores for left/right brow and left/right eye (0–100 scale).</td></tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div class="endpoint" id="list">
            <div class="endpoint-header">
              <span class="method GET">GET</span>
              <div class="endpoint-info">
                <h4>Get Conversations List</h4>
                <div class="url-row">
                  <div class="url-display">
                    <span class="base-url">{{ baseUrl }}</span><span class="route">/conversation/list</span>
                  </div>
                  <button class="copy-btn" (click)="copyUrl(baseUrl + '/conversation/list', $event)">📋 Copy URL</button>
                </div>
              </div>
            </div>
            <div class="endpoint-body">
              <p class="endpoint-desc">Returns a list of all conversations associated with your API key. Great for building dashboards or letting users browse their history. No parameters needed.</p>
              <div class="code-block">
                <div class="code-label res-label">Response</div>
                <pre>&#123;
                  <span class="key">"conversations"</span>: [

                  <span class="cmt">// Completed — no reports generated yet</span>
                  &#123;
                  <span class="key">"id"</span>:             <span class="num">6</span>,
                  <span class="key">"name"</span>:           <span class="str">"Interview with Candidate A"</span>,
                  <span class="key">"file_type"</span>:      <span class="str">"UPLOAD"</span>,
                  <span class="key">"status"</span>:         <span class="str">"COMPLETED"</span>,
                  <span class="key">"client_id"</span>:      <span class="num">8</span>,
                  <span class="key">"video_length"</span>:   <span class="bool">null</span>,
                  <span class="key">"single_speaker"</span>: <span class="str">"n"</span>,
                  <span class="key">"baseline"</span>: &#123;
                  <span class="key">"base_voice_start"</span>: <span class="num">5</span>,
                  <span class="key">"base_voice_end"</span>:   <span class="num">18</span>,
                  <span class="key">"baseline_start"</span>:   <span class="bool">null</span>,
                  <span class="key">"baseline_end"</span>:     <span class="bool">null</span>
                  &#125;,
                  <span class="key">"extra_content"</span>: &#123;&#125;,         <span class="cmt">// empty — no reports generated</span>
                  <span class="key">"createdAt"</span>: <span class="str">"2025-06-19T07:58:08.000Z"</span>,
                  <span class="key">"updatedAt"</span>: <span class="str">"2025-06-19T14:29:26.000Z"</span>
                  &#125;,

                  <span class="cmt">// Completed — report is ready</span>
                  &#123;
                  <span class="key">"id"</span>:             <span class="num">237</span>,
                  <span class="key">"name"</span>:           <span class="str">"Interrogation Session B"</span>,
                  <span class="key">"file_type"</span>:      <span class="str">"UPLOAD"</span>,
                  <span class="key">"status"</span>:         <span class="str">"COMPLETED"</span>,
                  <span class="key">"client_id"</span>:      <span class="num">8</span>,
                  <span class="key">"video_length"</span>:   <span class="bool">null</span>,
                  <span class="key">"single_speaker"</span>: <span class="str">"y"</span>,
                  <span class="key">"baseline"</span>: &#123;
                  <span class="key">"base_voice_start"</span>: <span class="num">0</span>,
                  <span class="key">"base_voice_end"</span>:   <span class="num">10</span>,
                  <span class="key">"baseline_start"</span>:   <span class="bool">null</span>,
                  <span class="key">"baseline_end"</span>:     <span class="bool">null</span>
                  &#125;,
                  <span class="key">"extra_content"</span>: &#123;
                  <span class="key">"reports"</span>: [
                  &#123;
                  <span class="key">"id"</span>:       <span class="str">"8927ac8c-0c58-41a9-a3e3-2cc8a6eaad6f"</span>,
                  <span class="key">"version"</span>: <span class="str">"4e34d7ea"</span>,
                  <span class="key">"template"</span>: &#123;
                  <span class="key">"name"</span>:  <span class="str">"Intelligence"</span>,
                  <span class="key">"value"</span>: <span class="str">"intellegence_template"</span>
                  &#125;,
                  <span class="key">"languages"</span>: [
                  &#123; <span class="key">"code"</span>: <span class="str">"EN"</span>, <span class="key">"name"</span>: <span class="str">"English"</span>, <span class="key">"status"</span>: <span class="str">"success"</span>, <span class="key">"progress"</span>: <span class="num">100</span>, <span class="key">"file_path"</span>: <span class="str">"external-results/conversation-237/reports/4e34d7ea/.../intellegence_template_EN.md"</span> &#125;,
                  &#123; <span class="key">"code"</span>: <span class="str">"HE"</span>, <span class="key">"name"</span>: <span class="str">"Hebrew"</span>,  <span class="key">"status"</span>: <span class="str">"success"</span>, <span class="key">"progress"</span>: <span class="num">100</span>, <span class="key">"file_path"</span>: <span class="str">"external-results/conversation-237/reports/4e34d7ea/.../intellegence_template_HE.md"</span> &#125;
                  ],
                  <span class="key">"header_data"</span>: &#123;
                  <span class="key">"Subject"</span>:         <span class="str">"John Doe"</span>,
                  <span class="key">"Prepared By"</span>:    <span class="str">"Agent Sarah Miller"</span>,
                  <span class="key">"Classification"</span>: <span class="str">"Confidential"</span>,
                  <span class="key">"Source Material"</span>: <span class="str">"Zoom Recording"</span>
                  &#125;,
                  <span class="key">"video_context"</span>:   <span class="str">"Security interview regarding the warehouse incident."</span>,
                  <span class="key">"context_snippet"</span>: <span class="str">"Security interview regarding the warehouse inc..."</span>,
                  <span class="key">"created_at"</span>:     <span class="str">"2026-02-26"</span>
                  &#125;
                  ]
                  &#125;,
                  <span class="key">"createdAt"</span>: <span class="str">"2025-10-30T11:53:07.000Z"</span>,
                  <span class="key">"updatedAt"</span>: <span class="str">"2025-10-30T12:05:40.000Z"</span>
                  &#125;,

                  <span class="cmt">// Still waiting — just created, video not yet uploaded/analyzed</span>
                  &#123;
                  <span class="key">"id"</span>:             <span class="num">458</span>,
                  <span class="key">"name"</span>:           <span class="str">"New Pending Conversation"</span>,
                  <span class="key">"file_type"</span>:      <span class="str">"UPLOAD"</span>,
                  <span class="key">"status"</span>:         <span class="str">"WAITING"</span>,
                  <span class="key">"client_id"</span>:      <span class="num">8</span>,
                  <span class="key">"video_length"</span>:   <span class="bool">null</span>,
                  <span class="key">"single_speaker"</span>: <span class="str">"y"</span>,
                  <span class="key">"baseline"</span>: &#123;
                  <span class="key">"base_voice_start"</span>: <span class="num">0</span>,
                  <span class="key">"base_voice_end"</span>:   <span class="num">10</span>,
                  <span class="key">"baseline_start"</span>:   <span class="bool">null</span>,
                  <span class="key">"baseline_end"</span>:     <span class="bool">null</span>
                  &#125;,
                  <span class="key">"extra_content"</span>: <span class="bool">null</span>,
                  <span class="key">"createdAt"</span>: <span class="str">"2026-02-26T18:12:02.000Z"</span>,
                  <span class="key">"updatedAt"</span>: <span class="str">"2026-02-26T18:12:02.000Z"</span>
                  &#125;

                  ]
                &#125;</pre>
              </div>

              <div class="callout tip">
                <span class="icon">💡</span>
                <span><strong>Reading <code>extra_content</code>:</strong> It can be <code class="inline">null</code> (conversation just created), an empty object <code class="inline">&#123;&#125;</code> (completed but no reports), or contain a <code class="inline">reports</code> array when reports have been generated. Always check before accessing.</span>
              </div>
            </div>
          </div>

          <div class="endpoint" id="update">
            <div class="endpoint-header">
              <span class="method PATCH">PATCH</span>
              <div class="endpoint-info">
                <h4>Update Conversation By ID</h4>
                <div class="url-row">
                  <div class="url-display">
                    <span class="base-url">{{ baseUrl }}</span><span class="route">/conversation/update/</span><span class="param">&#123;conversation_id&#125;</span>
                  </div>
                  <button class="copy-btn" (click)="copyUrl(baseUrl + '/conversation/update/{conversation_id}', $event)">📋 Copy URL</button>
                </div>
              </div>
            </div>
            <div class="endpoint-body">
              <p class="endpoint-desc">Update the metadata of an existing conversation — for example, to fix a name. Only the fields you include in the body will be changed. Replace <code class="inline">&#123;conversation_id&#125;</code> in the URL with your actual ID.</p>
              <div class="code-block">
                <div class="code-label req-label">Request Body</div>
                <pre>&#123;
                  <span class="key">"conversation_name"</span>: <span class="str">"Interview with John Doe - Round 2"</span>
                  <span class="key">"single_speaker"</span>:    <span class="str">"y"</span>,                            <span class="cmt">// optional: "y" or "n", default "y"</span>
                  <span class="key">"base_voice_start"</span>:  <span class="num">5</span>,                             <span class="cmt">// optional: seconds — start of voice baseline window</span>
                  <span class="key">"base_voice_end"</span>:    <span class="num">30</span>                            <span class="cmt">// optional: seconds — end of voice baseline window</span>
                &#125;</pre>
              </div>
              <div class="code-block">
                <div class="code-label res-label">Response</div>
                <pre>&#123;
                  <span class="key">"message"</span>:         <span class="str">"Conversation updated successfully"</span>
                &#125;</pre>
              </div>
            </div>
          </div>

          <div class="endpoint" id="delete">
            <div class="endpoint-header">
              <span class="method DELETE">DELETE</span>
              <div class="endpoint-info">
                <h4>Delete Conversation By ID</h4>
                <div class="url-row">
                  <div class="url-display">
                    <span class="base-url">{{ baseUrl }}</span><span class="route">/conversation/delete/</span><span class="param">&#123;conversation_id&#125;</span>
                  </div>
                  <button class="copy-btn" (click)="copyUrl(baseUrl + '/conversation/delete/{conversation_id}', $event)">📋 Copy URL</button>
                </div>
              </div>
            </div>
            <div class="endpoint-body">
              <p class="endpoint-desc">Permanently deletes a conversation record along with all associated analysis results, answers, and reports. Replace <code class="inline">&#123;conversation_id&#125;</code> in the URL with your actual ID.</p>
              <div class="callout danger">
                <span class="icon">🚨</span>
                <span><strong>Irreversible!</strong> All analysis results, Q&amp;A, and reports linked to this conversation will be permanently deleted. There is no undo.</span>
              </div>
              <div class="code-block">
                <div class="code-label res-label">Response</div>
                <pre>&#123;
                  <span class="key">"message"</span>:         <span class="str">"Conversation has been deleted successfully"</span>
                &#125;</pre>
              </div>
            </div>
          </div>

          <div class="endpoint" id="delete-video">
            <div class="endpoint-header">
              <span class="method DELETE">DELETE</span>
              <div class="endpoint-info">
                <h4>Delete Conversation Video File By ID</h4>
                <div class="url-row">
                  <div class="url-display">
                    <span class="base-url">{{ baseUrl }}</span><span class="route">/conversation/delete-video/</span><span class="param">&#123;conversation_id&#125;</span>
                  </div>
                  <button class="copy-btn" (click)="copyUrl(baseUrl + '/conversation/delete-video/{conversation_id}', $event)">📋 Copy URL</button>
                </div>
              </div>
            </div>
            <div class="endpoint-body">
              <p class="endpoint-desc">Removes only the raw video file from client's cloud storage — while preserving the conversation record and all analysis results. Perfect for data privacy compliance: keep the insights, delete the raw footage.</p>
              <div class="callout tip">
                <span class="icon">💡</span>
                <span>This is the recommended approach for GDPR/privacy compliance. The analysis data remains fully accessible after the video is deleted.</span>
              </div>
              <div class="code-block">
                <div class="code-label res-label">Response</div>
                <pre>&#123;
                  <span class="key">"message"</span>:         <span class="str">"Video file deleted successfully"</span>
                &#125;</pre>
              </div>
            </div>
          </div>
        </section>

        <div class="divider"></div>

        <section id="qa">
          <div class="section-header">
            <div class="section-icon green">🧠</div>
            <div>
              <h2>Questions &amp; Answers</h2>
              <p>The raw AI-generated insights extracted from the analyzed conversation</p>
            </div>
          </div>
          <p style="color:var(--text-muted);font-size:14px;margin-bottom:24px;">After analysis completes, Revealense answers a pre-configured set of behavioral and analytical questions about the speaker(s). These are the core intelligence outputs — the building blocks that reports are built from.</p>

          <div class="endpoint" id="all-answers">
            <div class="endpoint-header">
              <span class="method GET">GET</span>
              <div class="endpoint-info">
                <h4>Get All Questions And Answers By Conversation ID</h4>
                <div class="url-row">
                  <div class="url-display">
                    <span class="base-url">{{ baseUrl }}</span><span class="route">/conversation/questions/answers/</span><span class="param">&#123;conversation_id&#125;</span>
                  </div>
                  <button class="copy-btn" (click)="copyUrl(baseUrl + '/conversation/questions/answers/{conversation_id}', $event)">📋 Copy URL</button>
                </div>
              </div>
            </div>
            <div class="endpoint-body">
              <p class="endpoint-desc">Returns the complete set of question-answer pairs for a specific conversation. Replace <code class="inline">&#123;conversation_id&#125;</code> in the URL with your actual ID.</p>
              <div class="code-block">
                <div class="code-label res-label">Response</div>
                <pre>[
                  &#123;
                  <span class="key">"id"</span>:          <span class="num">1</span>,
                  <span class="key">"name"</span>:        <span class="str">"Identify segments where the individual appears to be intentionally manipulating or guiding the conversation."</span>,
                  <span class="key">"description"</span>: <span class="str">"It helps detect signs of conversational control or redirection that could indicate an attempt to evade or manipulate."</span>,
                  <span class="key">"answer"</span>:      <span class="str">"No Results Found"</span>,
                  <span class="key">"intervals"</span>:   []                  <span class="cmt">// empty — no matching segments detected</span>
                  &#125;,
                  &#123;
                  <span class="key">"id"</span>:          <span class="num">2</span>,
                  <span class="key">"name"</span>:        <span class="str">"Highlight any physiological changes that correlate with possible deception cues."</span>,
                  <span class="key">"description"</span>: <span class="str">"Points out where shifts in indicators like heart rate, voice tone, or pupil dilation might signal potential dishonesty."</span>,
                  <span class="key">"answer"</span>:      <span class="str">"The time segments listed below correspond to noticeable shifts in the individual's physiological state that may be associated with deceptive behavior."</span>,
                  <span class="key">"intervals"</span>:   [[<span class="num">15</span>, <span class="num">17</span>], [<span class="num">27</span>, <span class="num">28</span>], [<span class="num">29</span>, <span class="num">31</span>]]  <span class="cmt">// [start_second, end_second] pairs</span>
                  &#125;,
                  &#123;
                  <span class="key">"id"</span>:          <span class="num">3</span>,
                  <span class="key">"name"</span>:        <span class="str">"Highlight instances where signs of emotional suppression or concealment were observed."</span>,
                  <span class="key">"description"</span>: <span class="str">"Allows users to detect moments when an individual might attempt to hide genuine emotions."</span>,
                  <span class="key">"answer"</span>:      <span class="str">"The following intervals denote periods where the subject exhibited behaviors indicative of emotional suppression..."</span>,
                  <span class="key">"intervals"</span>:   [[<span class="num">0</span>, <span class="num">6</span>], [<span class="num">8</span>, <span class="num">9</span>], [<span class="num">11</span>, <span class="num">11</span>], [<span class="num">13</span>, <span class="num">25</span>], [<span class="num">27</span>, <span class="num">54</span>]]
                  &#125;
                  <span class="cmt">// ... one object per question</span>
                ]</pre>
              </div>
              <div class="callout tip">
                <span class="icon">💡</span>
                <span><strong>Understanding <code>intervals</code>:</strong> Each entry is a <code class="inline">[start_second, end_second]</code> pair indicating a time range in the video where the behavior was detected. An empty array <code class="inline">[]</code> means no relevant segments were found for that question, and the <code class="inline">answer</code> will be <code class="inline">"No Results Found"</code>.</span>
              </div>
            </div>
          </div>

          <div class="endpoint" id="single-answer">
            <div class="endpoint-header">
              <span class="method GET">GET</span>
              <div class="endpoint-info">
                <h4>Get Single Question Answer</h4>
                <div class="url-row">
                  <div class="url-display">
                    <span class="base-url">{{ baseUrl }}</span><span class="route">/conversation/answer/</span><span class="param">&#123;question_id&#125;</span><span class="route">/</span><span class="param">&#123;conversation_id&#125;</span>
                  </div>
                  <button class="copy-btn" (click)="copyUrl(baseUrl + '/conversation/answer/{question_id}/{conversation_id}', $event)">📋 Copy URL</button>
                </div>
              </div>
            </div>
            <div class="endpoint-body">
              <p class="endpoint-desc">Retrieves the answer to one specific question for a given conversation. Replace both <code class="inline">&#123;question_id&#125;</code> and <code class="inline">&#123;conversation_id&#125;</code> in the URL with your actual values. Get valid <code class="inline">question_id</code> values from <code class="inline">GET /client/questions</code>.</p>
              <div class="code-block">
                <div class="code-label res-label">Response</div>
                <pre>&#123;
                  <span class="key">"id"</span>:          <span class="num">7</span>,
                  <span class="key">"name"</span>:        <span class="str">"Mark periods where high cognitive load or mental strain was detected, potentially indicating memory recall or fabrication."</span>,
                  <span class="key">"description"</span>: <span class="str">"Captures signs of mental strain, which can arise during attempts to recall details or construct a false narrative."</span>,
                  <span class="key">"answer"</span>:      <span class="str">"The intervals listed below are characterized by physiological and behavioral indicators of significant cognitive effort..."</span>,
                  <span class="key">"intervals"</span>:   [[<span class="num">34</span>, <span class="num">34</span>], [<span class="num">40</span>, <span class="num">43</span>], [<span class="num">50</span>, <span class="num">55</span>]]
                &#125;</pre>
              </div>
            </div>
          </div>
        </section>

        <div class="divider"></div>

        <section id="reports">
          <div class="section-header">
            <div class="section-icon orange">📄</div>
            <div>
              <h2>Reports</h2>
              <p>Generate, retrieve, translate, and manage polished analysis documents</p>
            </div>
          </div>
          <p style="color:var(--text-muted);font-size:14px;margin-bottom:24px;">Reports are professionally formatted documents that package the conversation's analysis into a shareable deliverable. You choose the template style and target languages — Revealense handles the rest.</p>

          <div class="endpoint" id="gen-report">
            <div class="endpoint-header">
              <span class="method POST">POST</span>
              <div class="endpoint-info">
                <h4>Generate Conversation Report</h4>
                <div class="url-row">
                  <div class="url-display">
                    <span class="base-url">{{ baseUrl }}</span><span class="route">/conversation/report/generate/</span><span class="param">&#123;conversation_id&#125;</span>
                  </div>
                  <button class="copy-btn" (click)="copyUrl(baseUrl + '/conversation/report/generate/{conversation_id}', $event)">📋 Copy URL</button>
                </div>
              </div>
            </div>
            <div class="endpoint-body">
              <p class="endpoint-desc">Initiates creation of a formatted report from a completed analysis. You must specify which template to use and in which language(s) to generate the document. You can optionally add context about the video, the subject, and a classification level — this metadata appears in the report header.</p>
              <div class="callout tip">
                <span class="icon">💡</span>
                <span>Before calling this, use <code class="inline">GET {{ baseUrl }}/client/report/templates</code> and <code class="inline">GET {{ baseUrl }}/client/report/languages</code> to get the valid values.</span>
              </div>
              <div class="code-block">
                <div class="code-label req-label">Request Body</div>
                <pre>&#123;
                  <span class="key">"template"</span>: &#123;
                  <span class="key">"name"</span>:  <span class="str">"Intelligence"</span>,
                  <span class="key">"value"</span>: <span class="str">"intellegence_template"</span>
                  &#125;,
                  <span class="key">"report_languages"</span>: [
                  &#123; <span class="key">"name"</span>: <span class="str">"English"</span>, <span class="key">"prefix"</span>: <span class="str">"EN"</span> &#125;,
                  &#123; <span class="key">"name"</span>: <span class="str">"Hebrew"</span>,  <span class="key">"prefix"</span>: <span class="str">"HE"</span> &#125;
                  ],
                  <span class="key">"video_context"</span>:   <span class="str">"Security interview regarding the warehouse incident on Jan 12th."</span>,  <span class="cmt">// required, max 250 chars</span>
                  <span class="key">"classification"</span>:  <span class="str">"Confidential"</span>,       <span class="cmt">// optional: "Confidential" or "Not Confidential"</span>
                  <span class="key">"subject_name"</span>:    <span class="str">"John Doe"</span>,            <span class="cmt">// optional</span>
                  <span class="key">"generated_by"</span>:    <span class="str">"Agent Sarah Miller"</span>,  <span class="cmt">// optional</span>
                  <span class="key">"source_material"</span>: <span class="str">"Zoom recording"</span>       <span class="cmt">// optional</span>
                &#125;</pre>
              </div>
              <div class="table-wrap">
                <table>
                  <thead><tr><th>Field</th><th>Type</th><th>Required</th><th>Description</th></tr></thead>
                  <tbody>
                    <tr><td><code class="inline">template</code></td><td>object</td><td><span class="req">Required</span></td><td>The report template to use. Fetch valid options from <code class="inline">/client/report/templates</code>.</td></tr>
                    <tr><td><code class="inline">report_languages</code></td><td>array</td><td><span class="req">Required</span></td><td>One or more languages. Fetch valid options from <code class="inline">/client/report/languages</code>.</td></tr>
                    <tr><td><code class="inline">video_context</code></td><td>string</td><td><span class="req">Required</span></td><td>Plain-text description of the video (max 250 characters). Supports any language.</td></tr>
                    <tr><td><code class="inline">classification</code></td><td>string</td><td><span class="opt">Optional</span></td><td><code class="inline">"Confidential"</code> or <code class="inline">"Not Confidential"</code>.</td></tr>
                    <tr><td><code class="inline">subject_name</code></td><td>string</td><td><span class="opt">Optional</span></td><td>Full name of the person being analyzed.</td></tr>
                    <tr><td><code class="inline">generated_by</code></td><td>string</td><td><span class="opt">Optional</span></td><td>Name of the analyst or operator generating this report.</td></tr>
                    <tr><td><code class="inline">source_material</code></td><td>string</td><td><span class="opt">Optional</span></td><td>Where the video came from (e.g., <code class="inline">"YouTube"</code>, <code class="inline">"Zoom recording"</code>).</td></tr>
                  </tbody>
                </table>
              </div>
              <div class="code-block">
                <div class="code-label res-label">Response</div>
                <pre>&#123;
                  <span class="key">"success"</span>:   <span class="bool">true</span>,
                  <span class="key">"message"</span>:   <span class="str">"Report generation started."</span>,
                  <span class="key">"report_id"</span>: <span class="str">"8cb3ee6e-0751-43b1-a446-19cfbf23f655"</span>,  <span class="cmt">// the newly created report ID — save this!</span>

                  <span class="cmt">// "entity" is the full updated conversation object, including ALL reports.
                    // The newly generated report will have status "generating" and progress 0.
                  // Previously generated reports will still appear here with status "success".</span>
                  <span class="key">"entity"</span>: &#123;
                  <span class="key">"id"</span>:             <span class="num">455</span>,
                  <span class="key">"name"</span>:           <span class="str">"Test External Conversation"</span>,
                  <span class="key">"status"</span>:         <span class="str">"COMPLETED"</span>,
                  <span class="key">"video_length"</span>:   <span class="num">55</span>,
                  <span class="key">"single_speaker"</span>: <span class="str">"y"</span>,
                  <span class="key">"createdAt"</span>:      <span class="str">"2026-02-26T13:42:23.000Z"</span>,
                  <span class="key">"updatedAt"</span>:      <span class="str">"2026-03-01T09:33:33.000Z"</span>,
                  <span class="key">"extra_content"</span>: &#123;
                  <span class="key">"reports"</span>: [

                  <span class="cmt">// Previously generated report — already complete</span>
                  &#123;
                  <span class="key">"id"</span>:       <span class="str">"8927ac8c-0c58-41a9-a3e3-2cc8a6eaad6f"</span>,
                  <span class="key">"version"</span>: <span class="str">"4e34d7ea"</span>,
                  <span class="key">"template"</span>: &#123; <span class="key">"name"</span>: <span class="str">"Intelligence"</span>, <span class="key">"value"</span>: <span class="str">"intellegence_template"</span> &#125;,
                  <span class="key">"languages"</span>: [
                  &#123; <span class="key">"code"</span>: <span class="str">"EN"</span>, <span class="key">"status"</span>: <span class="str">"success"</span>, <span class="key">"progress"</span>: <span class="num">100</span>, <span class="key">"file_path"</span>: <span class="str">"external-results/conversation-455/reports/4e34d7ea/.../intellegence_template_EN.md"</span> &#125;,
                  &#123; <span class="key">"code"</span>: <span class="str">"HE"</span>, <span class="key">"status"</span>: <span class="str">"success"</span>, <span class="key">"progress"</span>: <span class="num">100</span>, <span class="key">"file_path"</span>: <span class="str">"external-results/conversation-455/reports/4e34d7ea/.../intellegence_template_HE.md"</span> &#125;
                  ],
                  <span class="key">"created_at"</span>: <span class="str">"2026-02-26"</span>
                  &#125;,

                  <span class="cmt">// Newly triggered report — still generating</span>
                  &#123;
                  <span class="key">"id"</span>:       <span class="str">"8cb3ee6e-0751-43b1-a446-19cfbf23f655"</span>,
                  <span class="key">"version"</span>: <span class="str">"d681c3b0"</span>,
                  <span class="key">"template"</span>: &#123; <span class="key">"name"</span>: <span class="str">"Intelligence"</span>, <span class="key">"value"</span>: <span class="str">"intellegence_template"</span> &#125;,
                  <span class="key">"languages"</span>: [
                  &#123; <span class="key">"code"</span>: <span class="str">"EN"</span>, <span class="key">"status"</span>: <span class="str">"generating"</span>, <span class="key">"progress"</span>: <span class="num">0</span>, <span class="key">"file_path"</span>: <span class="str">"external-results/conversation-455/reports/d681c3b0/.../intellegence_template_EN.md"</span> &#125;,
                  &#123; <span class="key">"code"</span>: <span class="str">"HE"</span>, <span class="key">"status"</span>: <span class="str">"generating"</span>, <span class="key">"progress"</span>: <span class="num">0</span>, <span class="key">"file_path"</span>: <span class="str">"external-results/conversation-455/reports/d681c3b0/.../intellegence_template_HE.md"</span> &#125;
                  ],
                  <span class="key">"header_data"</span>: &#123;
                  <span class="key">"Subject"</span>:         <span class="str">"John Doe"</span>,
                  <span class="key">"Prepared By"</span>:    <span class="str">"Agent Sarah Miller"</span>,
                  <span class="key">"Classification"</span>: <span class="str">"Confidential"</span>,
                  <span class="key">"Source Material"</span>: <span class="str">"Zoom Recording"</span>
                  &#125;,
                  <span class="key">"video_context"</span>:   <span class="str">"Security interview regarding the warehouse incident."</span>,
                  <span class="key">"context_snippet"</span>: <span class="str">"Security interview regarding the warehouse inc..."</span>,
                  <span class="key">"created_at"</span>:     <span class="str">"2026-03-01"</span>
                  &#125;

                  ]
                  &#125;
                  &#125;
                &#125;</pre>
              </div>
              <div class="callout warn">
                <span class="icon">⚠️</span>
                <span>Save the top-level <code class="inline">report_id</code> — this is the ID of the newly created report. The <code class="inline">entity.extra_content.reports</code> array contains <strong>all</strong> reports for the conversation, not just the new one.</span>
              </div>
              <div class="callout tip">
                <span class="icon">⏳</span>
                <span>The new report's language entries will have <code class="inline">status: "generating"</code> and <code class="inline">progress: 0</code> immediately after this call. Use <code class="inline">GET /conversation/report/list/&#123;conversation_id&#125;</code> to poll until <code class="inline">status</code> becomes <code class="inline">"success"</code>.</span>
              </div>
            </div>
          </div>

          <div class="endpoint" id="list-reports">
            <div class="endpoint-header">
              <span class="method GET">GET</span>
              <div class="endpoint-info">
                <h4>Get Conversation Report List</h4>
                <div class="url-row">
                  <div class="url-display">
                    <span class="base-url">{{ baseUrl }}</span><span class="route">/conversation/report/list/</span><span class="param">&#123;conversation_id&#125;</span>
                  </div>
                  <button class="copy-btn" (click)="copyUrl(baseUrl + '/conversation/report/list/{conversation_id}', $event)">📋 Copy URL</button>
                </div>
              </div>
            </div>
            <div class="endpoint-body">
              <p class="endpoint-desc">Lists all reports generated for a given conversation, including their status and the file paths of completed documents. Use the <code class="inline">file_path</code> values here when retrieving actual report content.</p>
              <div class="code-block">
                <div class="code-label res-label">Response</div>
                <pre>&#123;
                  <span class="key">"reports"</span>: [

                  <span class="cmt">// Report that finished successfully</span>
                  &#123;
                  <span class="key">"id"</span>:            <span class="str">"8927ac8c-0c58-41a9-a3e3-2cc8a6eaad6f"</span>,
                  <span class="key">"version"</span>:       <span class="str">"4e34d7ea"</span>,
                  <span class="key">"template"</span>: &#123;
                  <span class="key">"name"</span>:  <span class="str">"Intelligence"</span>,
                  <span class="key">"value"</span>: <span class="str">"intellegence_template"</span>
                  &#125;,
                  <span class="key">"template_name"</span>: <span class="str">"intellegence_template"</span>,
                  <span class="key">"languages"</span>: [
                  &#123; <span class="key">"code"</span>: <span class="str">"EN"</span>, <span class="key">"name"</span>: <span class="str">"English"</span>, <span class="key">"date"</span>: <span class="str">"2026-02-26"</span>, <span class="key">"status"</span>: <span class="str">"success"</span>,    <span class="key">"progress"</span>: <span class="num">100</span>, <span class="key">"file_path"</span>: <span class="str">"external-results/conversation-455/reports/4e34d7ea/Janus_protocol_2_6/intellegence_template/intellegence_template_EN.md"</span> &#125;,
                  &#123; <span class="key">"code"</span>: <span class="str">"HE"</span>, <span class="key">"name"</span>: <span class="str">"Hebrew"</span>,  <span class="key">"date"</span>: <span class="str">"2026-02-26"</span>, <span class="key">"status"</span>: <span class="str">"success"</span>,    <span class="key">"progress"</span>: <span class="num">100</span>, <span class="key">"file_path"</span>: <span class="str">"external-results/conversation-455/reports/4e34d7ea/Janus_protocol_2_6/intellegence_template/intellegence_template_HE.md"</span> &#125;
                  ],
                  <span class="key">"header_data"</span>: &#123;
                  <span class="key">"Subject"</span>:         <span class="str">"John Doe"</span>,
                  <span class="key">"Prepared By"</span>:    <span class="str">"Agent Sarah Miller"</span>,
                  <span class="key">"Classification"</span>: <span class="str">"Confidential"</span>,
                  <span class="key">"Source Material"</span>: <span class="str">"Video Analysis"</span>
                  &#125;,
                  <span class="key">"template_name"</span>:  <span class="str">"intellegence_template"</span>,
                  <span class="key">"video_context"</span>:  <span class="str">"Security interview regarding the warehouse incident."</span>,
                  <span class="key">"context_snippet"</span>: <span class="str">"Security interview regarding the warehouse inc..."</span>,
                  <span class="key">"created_at"</span>:     <span class="str">"2026-02-26"</span>
                  &#125;,

                  <span class="cmt">// Report that is still being generated — header_data shows placeholder text
                  // when optional fields were not provided at generation time</span>
                  &#123;
                  <span class="key">"id"</span>:       <span class="str">"8cb3ee6e-0751-43b1-a446-19cfbf23f655"</span>,
                  <span class="key">"version"</span>: <span class="str">"d681c3b0"</span>,
                  <span class="key">"template"</span>: &#123;
                  <span class="key">"name"</span>:  <span class="str">"Intelligence"</span>,
                  <span class="key">"value"</span>: <span class="str">"intellegence_template"</span>
                  &#125;,
                  <span class="key">"languages"</span>: [
                  &#123; <span class="key">"code"</span>: <span class="str">"EN"</span>, <span class="key">"name"</span>: <span class="str">"English"</span>, <span class="key">"date"</span>: <span class="str">"2026-03-01"</span>, <span class="key">"status"</span>: <span class="str">"generating"</span>, <span class="key">"progress"</span>: <span class="num">0</span>, <span class="key">"file_path"</span>: <span class="str">"external-results/conversation-455/reports/d681c3b0/Janus_protocol_2_6/intellegence_template/intellegence_template_EN.md"</span> &#125;,
                  &#123; <span class="key">"code"</span>: <span class="str">"HE"</span>, <span class="key">"name"</span>: <span class="str">"Hebrew"</span>,  <span class="key">"date"</span>: <span class="str">"2026-03-01"</span>, <span class="key">"status"</span>: <span class="str">"generating"</span>, <span class="key">"progress"</span>: <span class="num">0</span>, <span class="key">"file_path"</span>: <span class="str">"external-results/conversation-455/reports/d681c3b0/Janus_protocol_2_6/intellegence_template/intellegence_template_HE.md"</span> &#125;
                  ],
                  <span class="key">"header_data"</span>: &#123;
                  <span class="key">"Subject"</span>:         <span class="str">"Enter the subject full name."</span>,
                  <span class="key">"Prepared By"</span>:    <span class="str">"Enter the name of the person generating this report."</span>,
                  <span class="key">"Classification"</span>: <span class="str">"Select a security classification: Confidential or Not Confidential."</span>,
                  <span class="key">"Source Material"</span>: <span class="str">"Provide the original source of the video (e.g., YouTube, security camera, Zoom recording)."</span>
                  &#125;,
                  <span class="key">"template_name"</span>:  <span class="str">"intellegence_template"</span>,
                  <span class="key">"video_context"</span>:  <span class="str">"Briefly describe the video and its main subject in plain text (max 250 characters)."</span>,
                  <span class="key">"context_snippet"</span>: <span class="str">"Briefly describe the video and its main subject in..."</span>,
                  <span class="key">"created_at"</span>:     <span class="str">"2026-03-01"</span>
                  &#125;

                  ]
                &#125;</pre>
              </div>
              <div class="callout tip">
                <span class="icon">💡</span>
                <span>Use this endpoint to poll report generation progress. When all languages show <code class="inline">status: "success"</code> and <code class="inline">progress: 100</code>, the report is ready to retrieve. Copy the <code class="inline">file_path</code> from the desired language entry and pass it to the Get Report Content endpoint.</span>
              </div>
            </div>
          </div>

          <div class="endpoint" id="get-report">
            <div class="endpoint-header">
              <span class="method POST">POST</span>
              <div class="endpoint-info">
                <h4>Get Conversation Report Content</h4>
                <div class="url-row">
                  <div class="url-display">
                    <span class="base-url">{{ baseUrl }}</span><span class="route">/conversation/report/</span><span class="param">&#123;conversation_id&#125;</span>
                  </div>
                  <button class="copy-btn" (click)="copyUrl(baseUrl + '/conversation/report/{conversation_id}', $event)">📋 Copy URL</button>
                </div>
              </div>
            </div>
            <div class="endpoint-body">
              <p class="endpoint-desc">Fetches the actual content of a report document. Pass the <code class="inline">file_path</code> you received from the report list endpoint in the request body — you'll get the full report back as a Markdown string, ready to render or convert to PDF/Word.</p>
              <div class="code-block">
                <div class="code-label req-label">Request Body</div>
                <pre>&#123;
                  <span class="key">"file_path"</span>: <span class="str">"external-results/conversation-455/reports/a8eb10f0/intellegence_template/intellegence_template_EN.md"</span>
                &#125;</pre>
              </div>
              <div class="code-block">
                <div class="code-label res-label">Response</div>
                <pre>&#123;
                  <span class="key">"content"</span>:         <span class="str">"# Intelligence Report\n\n**Subject:** John Doe\n**Classification:** Confidential\n\n## Executive Summary\n\nDuring the analyzed conversation, the subject displayed..."</span>
                &#125;</pre>
              </div>
              <div class="callout tip">
                <span class="icon">💡</span>
                <span>The <code class="inline">content</code> field is a full Markdown document. Render it with any Markdown library or convert it to PDF/Word using tools like Pandoc.</span>
              </div>
            </div>
          </div>

          <div class="endpoint" id="translate-report">
            <div class="endpoint-header">
              <span class="method POST">POST</span>
              <div class="endpoint-info">
                <h4>Translate Conversation Report</h4>
                <div class="url-row">
                  <div class="url-display">
                    <span class="base-url">{{ baseUrl }}</span><span class="route">/conversation/report/translate/</span><span class="param">&#123;conversation_id&#125;</span><span class="route">/</span><span class="param">&#123;report_id&#125;</span>
                  </div>
                  <button class="copy-btn" (click)="copyUrl(baseUrl + '/conversation/report/translate/{conversation_id}/{report_id}', $event)">📋 Copy URL</button>
                </div>
              </div>
            </div>
            <div class="endpoint-body">
              <p class="endpoint-desc">Add additional language versions to an existing report without regenerating it from scratch. Replace both <code class="inline">&#123;conversation_id&#125;</code> and <code class="inline">&#123;report_id&#125;</code> in the URL. Translations are processed asynchronously.</p>
              <div class="code-block">
                <div class="code-label req-label">Request Body</div>
                <pre>&#123;
                  <span class="key">"languages"</span>: [
                  &#123; <span class="key">"name"</span>: <span class="str">"French"</span>, <span class="key">"prefix"</span>: <span class="str">"FR"</span> &#125;,
                  &#123; <span class="key">"name"</span>: <span class="str">"Arabic"</span>, <span class="key">"prefix"</span>: <span class="str">"AR"</span> &#125;
                  ]
                &#125;</pre>
              </div>
              <div class="code-block">
                <div class="code-label res-label">Response</div>
                <pre>&#123;
                  <span class="key">"success"</span>:   <span class="bool">true</span>,
                  <span class="key">"message"</span>:   <span class="str">"Report generation started."</span>,
                  <span class="key">"report_id"</span>: <span class="str">"8cb3ee6e-0751-43b1-a446-19cfbf23f655"</span>,  <span class="cmt">// the report that was translated</span>

                  <span class="cmt">// "entity" is the full updated conversation object.
                    // The translated report will show the new language with status "generating" and progress 0.
                  // All other languages on that report remain unchanged.</span>
                  <span class="key">"entity"</span>: &#123;
                  <span class="key">"id"</span>:             <span class="num">455</span>,
                  <span class="key">"name"</span>:           <span class="str">"Test External Conversation"</span>,
                  <span class="key">"status"</span>:         <span class="str">"COMPLETED"</span>,
                  <span class="key">"video_length"</span>:   <span class="num">55</span>,
                  <span class="key">"single_speaker"</span>: <span class="str">"y"</span>,
                  <span class="key">"createdAt"</span>:      <span class="str">"2026-02-26T13:42:23.000Z"</span>,
                  <span class="key">"updatedAt"</span>:      <span class="str">"2026-03-01T10:15:00.000Z"</span>,
                  <span class="key">"extra_content"</span>: &#123;
                  <span class="key">"reports"</span>: [
                  &#123;
                  <span class="key">"id"</span>:       <span class="str">"8cb3ee6e-0751-43b1-a446-19cfbf23f655"</span>,
                  <span class="key">"version"</span>: <span class="str">"d681c3b0"</span>,
                  <span class="key">"template"</span>: &#123; <span class="key">"name"</span>: <span class="str">"Intelligence"</span>, <span class="key">"value"</span>: <span class="str">"intellegence_template"</span> &#125;,
                  <span class="key">"languages"</span>: [
                  &#123; <span class="key">"code"</span>: <span class="str">"EN"</span>, <span class="key">"status"</span>: <span class="str">"success"</span>,    <span class="key">"progress"</span>: <span class="num">100</span>, <span class="key">"file_path"</span>: <span class="str">"external-results/conversation-455/reports/d681c3b0/.../intellegence_template_EN.md"</span> &#125;,
                  &#123; <span class="key">"code"</span>: <span class="str">"HE"</span>, <span class="key">"status"</span>: <span class="str">"success"</span>,    <span class="key">"progress"</span>: <span class="num">100</span>, <span class="key">"file_path"</span>: <span class="str">"external-results/conversation-455/reports/d681c3b0/.../intellegence_template_HE.md"</span> &#125;,
                  &#123; <span class="key">"code"</span>: <span class="str">"FR"</span>, <span class="key">"status"</span>: <span class="str">"generating"</span>, <span class="key">"progress"</span>: <span class="num">0</span>,   <span class="key">"file_path"</span>: <span class="str">"external-results/conversation-455/reports/d681c3b0/.../intellegence_template_FR.md"</span> &#125;
                  <span class="cmt">// newly added language — still generating</span>
                  ],
                  <span class="key">"created_at"</span>: <span class="str">"2026-03-01"</span>
                  &#125;
                  ]
                  &#125;
                  &#125;
                &#125;</pre>
              </div>
              <div class="callout tip">
                <span class="icon">⏳</span>
                <span>The newly added language will have <code class="inline">status: "generating"</code> and <code class="inline">progress: 0</code> immediately after this call. Poll <code class="inline">GET {{ baseUrl }}/conversation/report/list/&#123;conversation_id&#125;</code> until its <code class="inline">status</code> becomes <code class="inline">"success"</code> before attempting to retrieve the file.</span>
              </div>
            </div>
          </div>

          <div class="endpoint" id="delete-report">
            <div class="endpoint-header">
              <span class="method DELETE">DELETE</span>
              <div class="endpoint-info">
                <h4>Delete Conversation Report</h4>
                <div class="url-row">
                  <div class="url-display">
                    <span class="base-url">{{ baseUrl }}</span><span class="route">/conversation/report/</span><span class="param">&#123;conversation_id&#125;</span><span class="route">/</span><span class="param">&#123;report_id&#125;</span>
                  </div>
                  <button class="copy-btn" (click)="copyUrl(baseUrl + '/conversation/report/{conversation_id}/{report_id}', $event)">📋 Copy URL</button>
                </div>
              </div>
            </div>
            <div class="endpoint-body">
              <p class="endpoint-desc">Permanently removes a specific report (all language variants) from the system. Replace both <code class="inline">&#123;conversation_id&#125;</code> and <code class="inline">&#123;report_id&#125;</code> in the URL with your actual values.</p>
              <div class="code-block">
                <div class="code-label res-label">Response</div>
                <pre>&#123;
                  <span class="key">"message"</span>:         <span class="str">"Report deleted successfully"</span>
                &#125;</pre>
              </div>
            </div>
          </div>
        </section>

        <div class="divider"></div>

        <section id="client">
          <div class="section-header">
            <div class="section-icon green">⚙️</div>
            <div>
              <h2>Client Configuration</h2>
              <p>Discover what templates, languages, and questions your account supports</p>
            </div>
          </div>
          <p style="color:var(--text-muted);font-size:14px;margin-bottom:24px;">Always call these endpoints first — they return the exact values you need to pass into the report generation and Q&amp;A endpoints.</p>

          <div class="endpoint" id="templates">
            <div class="endpoint-header">
              <span class="method GET">GET</span>
              <div class="endpoint-info">
                <h4>Get Allowed Report Templates</h4>
                <div class="url-row">
                  <div class="url-display">
                    <span class="base-url">{{ baseUrl }}</span><span class="route">/client/report/templates</span>
                  </div>
                  <button class="copy-btn" (click)="copyUrl(baseUrl + '/client/report/templates', $event)">📋 Copy URL</button>
                </div>
              </div>
            </div>
            <div class="endpoint-body">
              <p class="endpoint-desc">Returns the list of report templates available to your account. Use the <code class="inline">value</code> field when specifying a template in the Generate Report request body.</p>
              <div class="code-block">
                <div class="code-label res-label">Response</div>
                <pre>&#123;
                  <span class="key">"templates"</span>: [
                  &#123;
                  <span class="key">"name"</span>:  <span class="str">"Profiling"</span>,
                  <span class="key">"value"</span>: <span class="str">"profiling_template"</span>
                  &#125;,
                  &#123;
                  <span class="key">"name"</span>:  <span class="str">"Credibility"</span>,
                  <span class="key">"value"</span>: <span class="str">"credibility_template"</span>
                  &#125;,
                  &#123;
                  <span class="key">"name"</span>:  <span class="str">"Intelligence"</span>,
                  <span class="key">"value"</span>: <span class="str">"intellegence_template"</span>
                  &#125;
                  ]
                &#125;</pre>
              </div>
            </div>
          </div>

          <div class="endpoint" id="languages">
            <div class="endpoint-header">
              <span class="method GET">GET</span>
              <div class="endpoint-info">
                <h4>Get Supported Report Languages</h4>
                <div class="url-row">
                  <div class="url-display">
                    <span class="base-url">{{ baseUrl }}</span><span class="route">/client/report/languages</span>
                  </div>
                  <button class="copy-btn" (click)="copyUrl(baseUrl + '/client/report/languages', $event)">📋 Copy URL</button>
                </div>
              </div>
            </div>
            <div class="endpoint-body">
              <p class="endpoint-desc">Returns all languages supported for report generation and translation. Use both the <code class="inline">name</code> and <code class="inline">prefix</code> fields exactly as returned here when specifying languages in report calls.</p>
              <div class="code-block">
                <div class="code-label res-label">Response</div>
                <pre>&#123;
                  <span class="key">"languages"</span>: [
                  &#123; <span class="key">"name"</span>: <span class="str">"English"</span>, <span class="key">"prefix"</span>: <span class="str">"EN"</span> &#125;,
                  &#123; <span class="key">"name"</span>: <span class="str">"Hebrew"</span>,  <span class="key">"prefix"</span>: <span class="str">"HE"</span> &#125;,
                  &#123; <span class="key">"name"</span>: <span class="str">"Arabic"</span>,  <span class="key">"prefix"</span>: <span class="str">"AR"</span> &#125;,
                  &#123; <span class="key">"name"</span>: <span class="str">"French"</span>,  <span class="key">"prefix"</span>: <span class="str">"FR"</span> &#125;,
                  &#123; <span class="key">"name"</span>: <span class="str">"Spanish"</span>, <span class="key">"prefix"</span>: <span class="str">"ES"</span> &#125;
                  ]
                &#125;</pre>
              </div>
            </div>
          </div>

          <div class="endpoint" id="questions">
            <div class="endpoint-header">
              <span class="method GET">GET</span>
              <div class="endpoint-info">
                <h4>Get Questions List</h4>
                <div class="url-row">
                  <div class="url-display">
                    <span class="base-url">{{ baseUrl }}</span><span class="route">/client/questions</span>
                  </div>
                  <button class="copy-btn" (click)="copyUrl(baseUrl + '/client/questions', $event)">📋 Copy URL</button>
                </div>
              </div>
            </div>
            <div class="endpoint-body">
              <p class="endpoint-desc">Returns all behavioral and analytical questions that Revealense evaluates for every conversation in your account. Use the <code class="inline">question_id</code> values when calling the single-answer endpoint.</p>
              <div class="code-block">
                <div class="code-label res-label">Response</div>
                <pre>[
                  &#123;
                  <span class="key">"id"</span>:          <span class="num">1</span>,
                  <span class="key">"name"</span>:        <span class="str">"Identify segments where the individual appears to be intentionally manipulating or guiding the conversation."</span>,
                  <span class="key">"description"</span>: <span class="str">"It helps detect signs of conversational control or redirection that could indicate an attempt to evade or manipulate."</span>
                  &#125;,
                  &#123;
                  <span class="key">"id"</span>:          <span class="num">2</span>,
                  <span class="key">"name"</span>:        <span class="str">"Highlight any physiological changes that correlate with possible deception cues."</span>,
                  <span class="key">"description"</span>: <span class="str">"Points out where shifts in indicators like heart rate, voice tone, or pupil dilation might signal potential dishonesty."</span>
                  &#125;,
                  &#123;
                  <span class="key">"id"</span>:          <span class="num">3</span>,
                  <span class="key">"name"</span>:        <span class="str">"Highlight instances where signs of emotional suppression or concealment were observed."</span>,
                  <span class="key">"description"</span>: <span class="str">"Allows users to detect moments when an individual might attempt to hide genuine emotions."</span>
                  &#125;
                  <span class="cmt">// ... one object per question</span>
                ]</pre>
              </div>
            </div>
          </div>
        </section>

        <div class="divider"></div>

        <section id="full-workflow">
          <div class="section-header">
            <div class="section-icon purple">🗺️</div>
            <div>
              <h2>Complete End-to-End Workflow</h2>
              <p>The full sequence from zero to finished report</p>
            </div>
          </div>
          <div class="full-flow">
            <div class="full-flow-item"><div class="ff-num">1</div><div class="ff-content"><h4>Discover Configuration</h4><p><span class="ff-method">GET {{ baseUrl }}/client/report/templates</span></p><p><span class="ff-method">GET {{ baseUrl }}/client/report/languages</span></p><p><span class="ff-method">GET {{ baseUrl }}/client/questions</span></p></div></div>
            <div class="full-flow-item"><div class="ff-num">2</div><div class="ff-content"><h4>Create a Conversation Record</h4><p><span class="ff-method">POST {{ baseUrl }}/conversation/create</span></p><p>→ Receive <code class="inline">conversation_id</code>, <code class="inline">signed_url</code>, <code class="inline">file_name</code></p></div></div>
            <div class="full-flow-item"><div class="ff-num">3</div><div class="ff-content"><h4>Upload the Video File</h4><p><span class="ff-method">PUT &#123;signed_url&#125;</span> — binary video body, Content-Type: video/mp4</p></div></div>
            <div class="full-flow-item"><div class="ff-num">4</div><div class="ff-content"><h4>Trigger the Analysis</h4><p><span class="ff-method">GET {{ baseUrl }}/conversation/analyze/&#123;conversation_id&#125;</span></p></div></div>
            <div class="full-flow-item"><div class="ff-num">5</div><div class="ff-content"><h4>Poll Until Completed</h4><p><span class="ff-method">GET {{ baseUrl }}/conversation/status/&#123;conversation_id&#125;</span></p><p>→ Repeat every 15–30s until status = <code class="inline">"Completed"</code></p></div></div>
            <div class="full-flow-item"><div class="ff-num">6</div><div class="ff-content"><h4>Read AI-Generated Insights</h4><p><span class="ff-method">GET {{ baseUrl }}/conversation/questions/answers/&#123;conversation_id&#125;</span></p></div></div>
            <div class="full-flow-item"><div class="ff-num">7</div><div class="ff-content"><h4>Generate a Report</h4><p><span class="ff-method">POST {{ baseUrl }}/conversation/report/generate/&#123;conversation_id&#125;</span></p><p>→ Receive <code class="inline">report_id</code></p></div></div>
            <div class="full-flow-item"><div class="ff-num">8</div><div class="ff-content"><h4>Get Report File Paths</h4><p><span class="ff-method">GET {{ baseUrl }}/conversation/report/list/&#123;conversation_id&#125;</span></p><p>→ Grab the <code class="inline">file_path</code> values</p></div></div>
            <div class="full-flow-item"><div class="ff-num">9</div><div class="ff-content"><h4>Retrieve Report Content</h4><p><span class="ff-method">POST {{ baseUrl }}/conversation/report/&#123;conversation_id&#125;</span></p><p>→ Pass <code class="inline">file_path</code> in request body</p></div></div>
            <div class="full-flow-item"><div class="ff-num">10</div><div class="ff-content"><h4>[Optional] Translate, Clean Up</h4><p><span class="ff-method">POST {{ baseUrl }}/conversation/report/translate/&#123;conversation_id&#125;/&#123;report_id&#125;</span></p><p><span class="ff-method">DELETE {{ baseUrl }}/conversation/delete-video/&#123;conversation_id&#125;</span></p></div></div>
          </div>
        </section>

        <div class="divider"></div>

        <section id="errors">
          <div class="section-header">
            <div class="section-icon red">🚨</div>
            <div>
              <h2>Error Reference</h2>
              <p>What each HTTP error code means and how to fix it</p>
            </div>
          </div>
          <div class="table-wrap">
            <table>
              <thead><tr><th>HTTP Code</th><th>Status</th><th>What It Means</th><th>How to Fix It</th></tr></thead>
              <tbody>
                <tr><td style="font-family:'Courier New',monospace;color:var(--accent3);font-weight:700">400</td><td>Bad Request</td><td>The request is malformed or missing required fields.</td><td>Check your request body against the field table for that endpoint.</td></tr>
                <tr><td style="font-family:'Courier New',monospace;color:var(--accent3);font-weight:700">401</td><td>Unauthorized</td><td>No API key provided, or the key is invalid.</td><td>Ensure the <code class="inline">revealense_key</code> header is present with a valid key.</td></tr>
                <tr><td style="font-family:'Courier New',monospace;color:var(--accent3);font-weight:700">403</td><td>Forbidden</td><td>Your key doesn't have permission to perform this action.</td><td>Contact your Account Admin to check key permissions.</td></tr>
                <tr><td style="font-family:'Courier New',monospace;color:var(--accent3);font-weight:700">404</td><td>Not Found</td><td>The <code class="inline">conversation_id</code>, <code class="inline">report_id</code>, or <code class="inline">question_id</code> doesn't exist.</td><td>Double-check all URL parameters. Use the list endpoints to confirm valid IDs.</td></tr>
                <tr><td style="font-family:'Courier New',monospace;color:var(--accent3);font-weight:700">409</td><td>Conflict</td><td>An action conflicts with the current state (e.g., starting analysis before uploading a video).</td><td>Ensure you follow the correct workflow order.</td></tr>
                <tr><td style="font-family:'Courier New',monospace;color:var(--accent3);font-weight:700">422</td><td>Unprocessable Entity</td><td>Required fields are missing or have invalid values.</td><td>Review the request body table. Make sure template and language values match those from <code class="inline">/client</code> endpoints.</td></tr>
                <tr><td style="font-family:'Courier New',monospace;color:var(--accent3);font-weight:700">429</td><td>Too Many Requests</td><td>You're polling too frequently or exceeded rate limits.</td><td>Add a delay between polling calls (minimum 10 seconds recommended).</td></tr>
                <tr><td style="font-family:'Courier New',monospace;color:var(--accent3);font-weight:700">500</td><td>Internal Server Error</td><td>Something went wrong on Revealense's side.</td><td>Retry after 1 minute. If it persists, contact support with your <code class="inline">conversation_id</code>.</td></tr>
              </tbody>
            </table>
          </div>
        </section>

        <footer>
          <span>Revealense API Documentation · V1</span>
          <span>Last updated: February 2026</span>
        </footer>

      </main>
    </div>
  </div>
</div>